export const getDirtyValues = (data, defaultValues) => {
  const diff = {}
  for (const [key, value] of Object.entries(data)) {
    if (defaultValues[key] !== value) {
      diff[key] = value
    }
  }
  return diff
}